<template>
  <a-spin :spinning="loading">
    <div class="list" v-if="agencyList.length > 0">
      <div class="col" v-for="(item,index) in agencyList" :key="index" @click="menuClick(item)">
        <div class="warp">
          <img :src="item.unitLogo||nullImg" class="or-img">
          <div class="content">
            <p><span class="or-title">{{$t('名称')}}：</span>{{item.unitName||'名称'}}</p>
            <p><span class="or-title">{{$t('地区')}}：</span>{{item.address||''}}</p>
            <p><span class="or-title">{{$t('类型')}}：</span>{{matchFun.agencyTypeText(item.unitType)}}</p>
          </div>
          <div class="check" :style="{background:joinAgency.agencyId == item.agencyId?'#b80000':''}">✓</div>
        </div>
      </div>
      <div class="btnContent">
        <div class="btn left20" @click="createAgency()" v-if="!hasMainAgency() && matchInfo.isDelegation === 0">创建单位</div>
      </div>
    </div>
    <a-alert
      message="提示"
      type="warning"
      show-icon
      v-if="agencyList.length == 0 && matchInfo.isDelegation === 0">
      <div slot="description">
        <span>{{$t('您还没有单位，请先创建一个参赛单位')}}</span>
        <div>
          <a-button type="danger" @click="createAgency()" size="small">点击创建</a-button>
        </div>
      </div>
    </a-alert>
    <a-alert
      message="提示"
      type="warning"
      show-icon
      v-if="agencyList.length == 0 && matchInfo.isDelegation === 1">
      <div slot="description">
        <span>{{$t('您还没有代表团，请先创建代表团！')}}</span>
        <a target="_black" href="https://jlpsport.matchn.cn/delegation">立即前往运动会官网创建（步骤：点击界面中代表团报名按钮->按照提示提交代表团信息）</a>
        <p style="color:#ccc;margin-top:20px">注：创建代表团时，请确保之前是否已经参加过该运动会了，已经创建过了。若已经创建，请联系之前创建的负责人，授权该代表团</p>
      </div>
    </a-alert>
    <EditAgency ref="editAgency" @ok="queryAgency"/>
  </a-spin>
</template>
<script>
import store from '@/store'
import EditAgency from '@comm/components/modal/EditAgency'
import matchFun from '@comm/utils/matchFun'
import { mapState } from 'vuex'
export default {
  components: {
    EditAgency
  },
  data () {
    return {
      loading: false,
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      matchFun: matchFun,
      nullImg: require('@comm/assets/join/null.png'),
      matchInfo: store.getters['match/matchInfo'],
      agencyList: []
    }
  },
  mounted () {
    // 如果是个人报名，直接前往选择运动员
    if (this.matchInfo.joinType === 3) {
      this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 3, agencyId: -1, teamId: -1}})
    } else {
      this.joinAgency.agencyId = null
      this.joinAgency.teamId = null
      this.joinAgency.agencyLogo = null
      this.joinAgency.abbreviation = null
      store.commit('join/JOIN_CHANGE_AGENCY_INFO', this.joinAgency)
      // 判断是否是代表团报名
      if (this.matchInfo.isDelegation) {
        this.queryDelegation()
      } else {
        this.queryAgency()
      }
      
    }
  },
  computed: {
    ...mapState({
      joinAgency: state => state.join.joinAgency
    })
  },
  methods: {
    queryDelegation () {
      this.loading = true
      this.$api.join.findEmpowerAgency({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          let dataList = res.data
          this.agencyList = dataList
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取机构列表失败')
      }).finally(_ => {
        console.log(_)
        this.loading = false
      })
    },
    queryAgency () {
      this.loading = true
      this.$api.join.agencyList().then(res => {
        if (res.status === 0) {
          let dataList = res.data
          this.agencyList = dataList
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取机构列表失败')
      }).finally(_ => {
        console.log(_)
        this.loading = false
      })
    },
    menuClick (item) {
      if (this.joinAgency.agencyId === item.agencyId) {
        this.joinAgency.agencyId = null
        this.joinAgency.teamId = null
        this.joinAgency.agencyLogo = null
        this.joinAgency.abbreviation = null
      } else {
        this.joinAgency.agencyId = item.agencyId
        this.joinAgency.teamId = item.teamId
        this.joinAgency.agencyLogo = item.unitLogo
        this.joinAgency.abbreviation = item.abbreviation
      }
      store.commit('join/JOIN_CHANGE_AGENCY_INFO', this.joinAgency)
    },
    // 创建机构
    createAgency () {
      this.$refs.editAgency.show(null)
    },
    // 是否有主机构
    hasMainAgency () {
      if (this.agencyList.length > 0) {
        for (let i = 0; i < this.agencyList.length; i++) {
          let agency = this.agencyList[i]
          if (agency.isMain === 1) {
            return true
          }
        }
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list{
  .col{
    margin-bottom: 30px;
    float: left;
    width: 50%;
    &:nth-child(even){
      .warp{
        margin-left: 3%;
      }
    }
  }
  .warp{
    width: 97%;
    height: 150px;
    border:1px solid #e8e8e8;
    border-radius: 2px;
    display: flex;
    flex-direction: row;
    position: relative;
    background-color:#fff;
    box-shadow: rgba(196, 196, 196, 0.5) 1px 1px 3px 1px;
    &:hover{
      cursor: pointer;
      background-color: #f7f7f7;
    }
    .or-img{
      width: 130px;
      height: 130px;
      border-radius: 50%;
      margin-top: auto;
      margin-bottom: auto;
      padding: 10px;
    }
    .content{
      height: 100%;
      display: flex;
      flex-direction: column;
      p{
        flex: 1;
        color: #000;
        line-height: 50px;
        margin-bottom: 0;
        .or-title{
          color: #999;
        }
      }
    }
    .check{
      position: absolute;
      right: 0;
      color: #fff;
      width: 80px;
      font-size: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      background-color: #e8e8e8;
    }
  }
  .active{
    .check{
      background-color: red;
    }
  }
}
.btnContent {
  clear: both;
  text-align: center;
  .btn{
    color: #fff;
    width: 100px;
    height: 30px;
    clear: both;
    line-height: 30px;
    margin: 0 auto;
    right: 250px;
    bottom: 29px;
    text-align: center;
    border-radius: 2px;
    background-color: #b80000;
    cursor:pointer;
    display: inline-block;
  }
  .left20 {
    margin-left: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/comm/components/join/agency/AgencyList.vue